import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchAllUnitMeasurements,
  deleteUnitMeasurementById,
  updateUnitMeasurementsById,
  createNewUnitMeasurement,
} from '../../../../redux/actions/unit_measurementsActions';

import { formatUnityMesasurementCategory } from '../../../../utils/functionsFormatPatterns/functionFormatDiet'
import ModalForms from '../../../../components/ConfirmationModal/ModalForms';
import { useModalFeedback } from '../../../../hooks/useModalFeedback';
import SearchBar from '../../../../components/SearchBar/SearchBar';
import { MdDelete, MdCreate } from 'react-icons/md';
import { FaClipboardCheck, FaMoneyBillWave } from "react-icons/fa";
import LoadingEllipsis from '../../../../components/LoadingEllipsis/LoadingEllipsis';
import Pagination from '../../../../components/Pagination/Pagination';
import favoriteIco from '../../../../assets/img/fruitLogo.png';

import CreateUnityMeasurements from './CreateUnityMeasurements';

import '../../../../Mobile.css';
import '../styles/UnityMeasurements.css';


function UnitMeasurements() {
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const icoUpdate = <MdCreate className='icon' />;
  const icoTrash = <MdDelete className='icon' />;
  const icoType = <FaClipboardCheck className='mobileIcon' />;
  const icoFee = <FaMoneyBillWave className='mobileIcon' />;
  const [filteredTypes, setFilteredTypes] = useState([]);
  const [, setSearchText] = useState("");

  const {
    showModal,
    message,
    showButtons,
    isDeleting,
    setIsDeleting,
    onConfirm,
    onCancel,
    showConfirmation,
    showInfo,
    hideModal,
  } = useModalFeedback();


  const [editingType, setEditingType] = useState(null);

  const updateBtn = "Editar";
  const deleteBtn = "Deletar";

  const { unit_measurements = [], loading, error } = useSelector((state) => state.unit_measurement);

  // console.log(unit_measurements)

  useEffect(() => {
    dispatch(fetchAllUnitMeasurements());
  }, [dispatch]);

  useEffect(() => {
    if (unit_measurements && unit_measurements.length) {
      setFilteredTypes(unit_measurements);
    }
  }, [unit_measurements]);

  const handleDelete = (unit_measurement_id) => {
    const unit = unit_measurements.find(u => u.unit_measurement_id === unit_measurement_id);
    const unitName = unit?.unit_name || 'Unidade desconhecida';

    showConfirmation(
      `Tem certeza que deseja remover a unidade de medida: "${unitName}"?`,
      () => confirmDelete(unit_measurement_id, unitName),
      hideModal
    );
  };

  const confirmDelete = async (unit_measurement_id, unitName) => {
    setIsDeleting(true);
    try {
      const result = await dispatch(deleteUnitMeasurementById(unit_measurement_id));

      if (!result.error) {
        showInfo(`"${unitName}" removida com sucesso!`);
        dispatch(fetchAllUnitMeasurements());
      } else {
        showInfo(`Erro ao deletar "${unitName}": ${result.error}`, 3000);
      }
    } catch (err) {
      showInfo(`Erro ao deletar "${unitName}": ${err.message}`, 3000);
    } finally {
      setIsDeleting(false);
    }
  };


  const handleEdit = (unit) => {
    setEditingType(unit);
  };

  const handleCreateNew = () => {
    setEditingType({
      unit_name: '',
      unit_abbreviation: '',
      equivalent_value: 0,
      favorite_item: '',
      category: ''
    });
  };

  const handleSave = async (unitData) => {
    const {
      unit_measurement_id,
      unit_name,
      unit_abbreviation,
      equivalent_value,
      favorite_item,
      category
    } = unitData;

    const data = {
      unit_name,
      unit_abbreviation,
      equivalent_value: Number(equivalent_value),
      favorite_item,
      category
    };

    console.log('Enviando dados:', data);

    try {
      let result;

      if (unit_measurement_id) {
        result = await dispatch(updateUnitMeasurementsById({ unit_measurement_id, ...data }));
      } else {
        result = await dispatch(createNewUnitMeasurement(data));
      }

      // Verifica se a requisição falhou
      if (result.meta.requestStatus === 'rejected') {
        const errorMsg = result.payload?.message || result.payload || 'Erro ao salvar unidade.';
        showInfo(`Erro: ${errorMsg}`, 3000);
        return; // evita seguir para setEditingType
      }

      showInfo(unit_measurement_id
        ? 'Unidade de medida atualizada com sucesso!'
        : 'Unidade de medida criada com sucesso!'
      );

      setEditingType(null);
      dispatch(fetchAllUnitMeasurements());

    } catch (error) {
      showInfo(`Erro inesperado: ${error.message || error}`, 3000);
    }
  };



  const handleSearch = (searchText) => {
    setSearchText(searchText);
    const filtered = unit_measurements.filter(unit =>
      `${unit.unit_name || ''} ${unit.description || ''} ${unit.equivalent_value || ''} ${unit.category || ''}`.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredTypes(filtered);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const getPageButtonClass = (index) => (currentPage === index + 1 ? 'active' : '');

  const paginatedTypes = filteredTypes.slice(indexOfFirstItem, indexOfLastItem);


  return (
    <>
      {showModal && (
        <ModalForms
          message={message}
          onConfirm={onConfirm}
          onCancel={onCancel}
          isDeleting={isDeleting}
          showButtons={showButtons}
        />
      )}

      {editingType ? (
        <CreateUnityMeasurements
          type={editingType}
          onSave={handleSave}
          onCancel={() => setEditingType(null)}
        />
      ) : (
        <div className="boxUnitMeasurements">
          <h3>Unidades de Medida</h3>
          <div className="searchAdd">
            <div className="col1">
              <SearchBar onSearch={handleSearch} />
            </div>
            <div className="col2">
              <button className="addBtn" onClick={handleCreateNew}>
                Criar Nova Unidade de Medida
              </button>
            </div>

          </div>
          <h6>Resultados Retornados: {unit_measurements.length}</h6>
          <table className='unitMeasurementsTable'>
            <thead>
              <tr>
                <td>Nome</td>
                <td>Abreviação</td>
                <td>Valor Equivalente</td>
                <td>Item Favorito</td>
                <td>Categoria</td>
                <td>Ações</td>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <LoadingEllipsis message='Carregando Unidade de Medida' />
                </tr>
              ) : paginatedTypes.length === 0 ? (
                <tr>
                  <td className="colLine">nenhum registro localizado</td>
                </tr>
              ) : (
                paginatedTypes.map((unit) => (
                  <tr key={unit.unit_measurement_id}>
                    <td>
                      {icoType} {unit.unit_name}
                    </td>
                    <td>
                      {icoType} {unit.unit_abbreviation}
                    </td>
                    <td>
                      {icoFee} {unit.equivalent_value.toFixed(2)}
                    </td>
                    <td className="favorite-feedback">
                      <img
                        src={favoriteIco}
                        alt="Favorito"
                        className={unit.favorite_item === 1 ? 'icon-colored' : 'icon-grayscale'}
                      />
                      <span>{unit.favorite_item === 1 ? 'Favorito' : 'Comum'}</span>
                    </td>
                    <td>{formatUnityMesasurementCategory(unit.category)}</td>
                    <td className="actions">
                      <button
                        className='icoBtn'
                        type="button"
                        onClick={() => handleEdit(unit)}
                        data-tip={updateBtn}
                      >
                        {icoUpdate}
                      </button>
                      <button
                        className='icoBtn'
                        type="button"
                        onClick={() => handleDelete(unit.unit_measurement_id)}
                        data-tip={deleteBtn}
                      >
                        {icoTrash}
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {/* Paginação */}
          {unit_measurements.length > 0 && (
            <Pagination totalItems={unit_measurements.length} itemsPerPage={itemsPerPage} currentPage={currentPage} paginate={paginate} />
          )}

        </div>
      )}
    </>
  );
}

export default UnitMeasurements;